import logoImg from '@/assets/img/icon/logo.png';

interface LogoProps {
    className?: string;
}

export const Logo = ({ className = '' }: LogoProps) => {
    return (
        <div className={`inline-flex justify-start items-center gap-3 ${className}`}>
            <img className="h-6 lg:w-8 lg:h-8" src={logoImg} alt="Crypto Crap Logo" />
            <h1 className="justify-start text-white text-xl font-medium font-outfit leading-8">Crypto Crap</h1>
        </div>
    );
};